<template>
  <v-container
    :style="$vuetify.theme.dark ? '' : 'background: #eeeeee'"
    style="min-height: 110vh"
  >
    <!-- <v-row class="mb-1">
      <v-col cols="12" md="9">
        <h2 class="mt-1">
          <span class="grey--text">{{ $t("package.newpackage.title") }} </span>
        </h2>
      </v-col>
    </v-row> -->
    <v-card class="pa-3">
      <v-card-text>
        <v-form v-model="valid" ref="form" class="mt-6">
          <v-row>
            <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
              <v-autocomplete
                :items="geoPlace"
                :label="$t('package.newpackage.CompanyAddress')"
                outlined
                v-model="src_place"
                :rules="[rules.required]"
                item-text="address"
                return-object
                persistent-hint
                auto-select-first
                :hint="viewAdress()"
                class="ma-1 pa-0"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>

                    <v-list-item-subtitle>
                      {{ item.address }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{ item.number == "" ? " " : item.number }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      <span
                        v-if="item.collect_cash == 1"
                        style="color: green"
                        >{{ $t("package.newpackage.supportCash") }}</span
                      >
                      <span v-else style="color: red">{{
                        $t("package.newpackage.noCash")
                      }}</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
              <v-select
                class="ma-1"
                v-model="typeOfchecked"
                :rules="[rules.required]"
                :items="src_place.costModel"
                :item-text="formatItemText"
                auto-select-first
                :label="$t('package.newpackage.type')"
                outlined
                return-object
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ item.type }} - {{ item.weight }} kg</v-list-item-title
                    >

                    <v-list-item-subtitle>
                      {{ $t("costModel.cityBaseCosts") }}
                      {{ item.cityBaseCosts }}
                      {{
                        $i18n.locale == "ar"
                          ? item.ar_currency
                          : item.en_currency
                      }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{ $t("costModel.costPerKilometer")
                      }}{{ item.costPerKilometer }}
                      {{
                        $i18n.locale == "ar"
                          ? item.ar_currency
                          : item.en_currency
                      }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{ $t("costModel.costPerKg") }}{{ item.costPerKg }}
                      {{
                        $i18n.locale == "ar"
                          ? item.ar_currency
                          : item.en_currency
                      }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
              <v-text-field
                outlined
                class="ma-1 custom-hint"
                v-model="data.sender_name"
                :label="$t('package.newpackage.senderName')"
                :rules="[rules.required]"
                :persistent-hint="
                  blackListData.sender_name == null ? false : true
                "
                @change="checkBlackList('sender_name', data.sender_name)"
                :append-icon="
                  blackListData.sender_name != null ? 'mdi-information' : ''
                "
                @click:append="openBlackListDialog(blackListData.sender_name)"
                :hint="
                  blackListData.sender_name == null
                    ? ''
                    : $t('package.blackList')
                "
              ></v-text-field> </v-col
            ><v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
              <v-text-field
                outlined
                v-model="data.sender_address"
                class="ma-1"
                :label="$t('package.newpackage.senderAddress')"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
              <v-text-field
                outlined
                class="ma-1 custom-hint"
                v-model="data.dest_name"
                :label="$t('package.newpackage.ClientName')"
                :rules="[rules.required]"
                :persistent-hint="
                  blackListData.full_name == null ? false : true
                "
                @change="checkBlackList('full_name', data.dest_name)"
                :append-icon="
                  blackListData.full_name != null ? 'mdi-information' : ''
                "
                @click:append="openBlackListDialog(blackListData.full_name)"
                :hint="
                  blackListData.full_name == null ? '' : $t('package.blackList')
                "
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
              <v-autocomplete
                :items="cities"
                :label="$t('package.newpackage.ClientCity')"
                outlined
                v-model="data.dest_city"
                :rules="[rules.required]"
                :item-text="$i18n.locale == 'ar' ? 'ar_name' : 'en_name'"
                return-object
                persistent-hint
                auto-select-first
                class="ma-1 pa-0"
              ></v-autocomplete>
            </v-col>
            <!--  -->
            <v-col cols="12" sm="3" class="ma-0 pa-0" v-if="src_place?.id">
              <p class="ma-0 pa-0">
                {{ $t("package.newpackage.pickFromDestCenter") }}
              </p>
              <v-btn-toggle
                class="ma-0 pa-0"
                dense
                v-model="data.pickup"
                group
                color="green"
                mandatory
              >
                <v-btn
                  :value="1"
                  :disabled="src_place.collect_cash == 0 ? true : false"
                >
                  <v-icon>Yes</v-icon>
                </v-btn>
                <v-btn
                  :value="0"
                  :disabled="src_place.collect_cash == 0 ? true : false"
                >
                  <v-icon>No</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-col>

            <v-col
              v-if="data.dest_city?.companies.length != 0 && data.pickup == 1"
              cols="12"
              sm="9"
              md="9"
              class="ma-0 pa-0"
            >
              <v-autocomplete
                :items="data.dest_city?.companies"
                :label="$t('package.newpackage.centerdest')"
                outlined
                v-model="future_dest"
                :rules="[rules.required]"
                item-text="address"
                return-object
                persistent-hint
                auto-select-first
                :hint="future_dest?.name"
                class="ma-1 pa-0"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>

                    <v-list-item-subtitle>
                      {{ item.address }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{ item.number == "" ? " " : item.number }}
                    </v-list-item-subtitle>
                    <!-- <v-list-item-subtitle>
                      <span
                        v-if="item.collect_cash == 1"
                        style="color: green"
                        >{{ $t("package.newpackage.supportCash") }}</span
                      >
                      <span v-else style="color: red">{{
                        $t("package.newpackage.noCash")
                      }}</span>
                    </v-list-item-subtitle> -->
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col
              v-else-if="data.dest_city?.companies.length == 0"
              cols="12"
              sm="9"
              md="9"
              class="ma-0 pa-0"
            >
              {{ $t("package.newpackage.NoDestCenter") }}
            </v-col>
            <v-col v-else cols="12" sm="9" md="9" class="ma-0 pa-0"> </v-col>
            <!--             {{ data.dest_city?.companies }} -->

            <!-- <v-col cols="12" sm="6" class="ma-0 pa-0">
               
              </v-col> -->
            <v-col cols="12" sm="4" md="4" class="ma-0 pa-0">
              <vuetify-google-autocomplete
                ref="address"
                id="map"
                outlined
                class="ma-1 pa-0"
                classname="form-control"
                v-on:placechanged="getAddressDest"
                :country="$cookies.get('code')"
                :rules="[rules.required]"
                persistent-hint
                v-model="data.dest_address"
                :label="$t('package.newpackage.clientAddress')"
                :hint="data.dest_address"
              >
              </vuetify-google-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="ma-0 pa-0">
              <v-text-field
                outlined
                v-model="data.dest_number"
                class="ma-1 custom-hint"
                :persistent-hint="blackListData.number == null ? false : true"
                @change="checkBlackList('number', data.dest_number)"
                :append-icon="
                  blackListData.number != null ? 'mdi-information' : ''
                "
                @click:append="openBlackListDialog(blackListData.number)"
                :hint="
                  blackListData.number == null ? '' : $t('package.blackList')
                "
                :label="$t('package.newpackage.phone')"
                :rules="[rules.required]"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="ma-0 pa-0">
              <v-text-field
                outlined
                class="ma-1 custom-hint"
                :rules="[rules.emailMatch]"
                v-model="data.dest_email"
                :label="$t('package.newpackage.dest_email')"
                :persistent-hint="blackListData.email == null ? false : true"
                @change="checkBlackList('email', data.email)"
                :append-icon="
                  blackListData.email != null ? 'mdi-information' : ''
                "
                @click:append="openBlackListDialog(blackListData.email)"
                :hint="
                  blackListData.email == null ? '' : $t('package.blackList')
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" class="ma-0 pa-0">
              <v-row class="ma-0 pa-0">
                <v-col cols="12" sm="3" class="ma-0 pa-0">
                  <v-text-field
                    outlined
                    class="ma-1"
                    :label="$t('package.newpackage.costDelivery')"
                    v-model="data.cost_shipping"
                    :prefix="
                      $i18n.locale == 'ar'
                        ? typeOfchecked.ar_currency
                        : typeOfchecked.en_currency
                    "
                    append-icon="  mdi-information  "
                    persistent-hint
                    @click:append="infoAImodel"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="3" class="ma-0 pa-0">
                  <v-text-field
                    outlined
                    class="ma-1"
                    :label="$t('package.newpackage.costpackage')"
                    v-model="data.price"
                    :prefix="
                      $i18n.locale == 'ar'
                        ? typeOfchecked.ar_currency
                        : typeOfchecked.en_currency
                    "
                    :disabled="data.cost_box == 0 ? true : false"
                    persistent-hint
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    :rules="data.cost_box == 1 ? [rules.required] : []"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" class="ma-0 pa-0" v-if="src_place?.id">
                  <p class="ma-0 pa-0">
                    {{ $t("package.newpackage.price_box") }}
                  </p>
                  <span v-if="src_place.collect_cash == 0" style="color: red">{{
                    $t("package.newpackage.noCash")
                  }}</span>
                  <v-btn-toggle
                    class="ma-0 pa-0"
                    dense
                    v-model="data.cost_box"
                    group
                    color="green"
                    mandatory
                  >
                    <v-btn
                      :value="1"
                      :disabled="src_place.collect_cash == 0 ? true : false"
                    >
                      <v-icon>Yes</v-icon>
                    </v-btn>
                    <v-btn
                      :value="0"
                      :disabled="src_place.collect_cash == 0 ? true : false"
                    >
                      <v-icon>No</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="ma-0 pa-0">
              <v-textarea
                outlined
                v-model="data.note"
                :label="$t('package.newpackage.note')"
                required
                :rules="[rules.required]"
              ></v-textarea>
            </v-col>
            <!-- <v-col cols="12" class="ma-0 pa-0">
                <v-list-item>
                  <v-list-item-content>
                    <v-switch
                      color="green"
                      v-model="data.verification"
                      prepend-icon="mdi-dialpad"
                      :label="$t('package.newpackage.verification')"
                    ></v-switch>
                  </v-list-item-content>
                </v-list-item>
              </v-col> -->
          </v-row>
        </v-form>
        <small>{{ $t("package.newpackage.info") }}</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="handleReset">
          {{ $t("package.newpackage.resetBtn") }}
        </v-btn>

        <v-btn
          color="primary"
          outlined
          :loading="clicked"
          :disabled="clicked"
          @click="postpackage(false)"
        >
          {{ $t("btn.save") }}
        </v-btn>
        <v-btn
          color="primary"
          :loading="clicked"
          :disabled="clicked"
          @click="postpackage(true)"
        >
          {{ $t("btn.save_print") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <infoAiModel
      :infoAiModel="shippingCostModelDialog"
      :data="shippingCostModel"
      @close-dialog="closeInfoAiModel"
      :loading="loadingShippingCostModel"
    />
    <blackListInfo
      :dialog="blackListDialog"
      :data="viewData_BlackList"
      @close-dialog="closeBlackListDialog"
    />
  </v-container>
</template>

<script>
//   import LoadCard from "@/views/components/LoadCard.vue";
import infoAiModel from "../infoAiModel.vue";
import blackListInfo from "../blackListInfo.vue";
import Print from "@/plugins/print.js";
import VuetifyGoogleAutocomplete from "vuetify-google-autocomplete";
import { mapActions, mapState, mapGetters } from "vuex";
import cl from "@/services/packages.js";
export default {
  data() {
    return {
      viewData_BlackList: {},
      valid: true,
      blackListDialog: false,
      blackListData: {
        number: null,
        email: null,
        full_name: null,
        sender_name: null,
      },
      shippingCostModel: {},
      shippingCostModelDialog: false,
      loadingShippingCostModel: true,
      address: "",
      src_place: "",
      typeOfchecked: {},
      future_dest: { cid: null, src: null },
      data: {
        endpoint: null,
        pickup: 0,
        cost_box: 0,
        verification: 0,
        price: 0,
        express: false,
        dest_name: null,
        dest_number: null,
        dest_lat: null,
        dest_lng: null,
        dest_address: null,
        dest_email: null,

        sender_email: null,
        sender_name: null,
        sender_address: null,

        cost_shipping: null,
        note: null,
      },

      clicked: false,
      rules: {
        required: null,
        emailMatch: null,
      },
    };
  },
  created() {
    this.rules.required = (v) => !!v || this.$t("rules.require");
    this.rules.emailMatch = (v) =>
      !v ||
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v
      ) ||
      this.$t("rules.emailMatch");
  },
  components: { VuetifyGoogleAutocomplete, infoAiModel, blackListInfo },
  computed: {
    ...mapState(["geoPlace", "typePlace", "cities"]),
    ...mapGetters("employees", ["employees"]),

    userMe() {
      return this.$store.getters["users/userMe"];
    },
  },
  mounted() {
    this.src_place = this.geoPlace[0];
  },
  watch: {
    "data.dest_city"(newVal, oldVal) {
      // console.log("dest_city changed from", oldVal, "to", newVal);
      this.getShippingCost();
    },
    "data.dest_address"(newVal, oldVal) {
      // console.log("dest_address changed from", oldVal, "to", newVal);
      this.getShippingCost();
    },
    "data.src_place"(newVal, oldVal) {
      // console.log("src_place changed from", oldVal, "to", newVal);
      this.getShippingCost();
    },
    typeOfchecked(newVal, oldVal) {
      // console.log("src_place changed from", oldVal, "to", newVal);
      this.getShippingCost();
    },
  },
  methods: {
    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */

    getAddressDest(addressData, placeResultData, id) {
      this.data.dest_lat = addressData.latitude;
      this.data.dest_lng = addressData.longitude;
    },
    checkBlackList(item, val) {
      // if (this.data.number.length == 3)
      let t = {};
      t[item] = val; //this.data.dest_number
      cl.checkBlackList(t).then((res) => {
        this.blackListData[item] = res.data.data;
      });
    },
    infoAImodel() {
      this.shippingCostModelDialog = true;
    },
    closeBlackListDialog() {
      this.blackListDialog = false;
    },
    openBlackListDialog(data) {
      this.viewData_BlackList = data;
      this.blackListDialog = true;
    },
    getShippingCost() {
      this.data.cost_shipping = 0;
      if (this.typeOfchecked.modelV1 != 1) return;

      this.loadingShippingCostModel = true;

      let payload = {
        id_cost: this.typeOfchecked?.id,
        src_id: this.src_place.id,

        dest_city: this.data.dest_city?.id,

        dest_address: this.data.dest_address,
        dest_lat: this.data.dest_lat,
        dest_lng: this.data.dest_lng,
      };

      cl.getShippingCost(payload)
        .then((res) => {
          this.shippingCostModel = res.data.data;
          this.loadingShippingCostModel = false;
          this.data.cost_shipping = res.data.data.totalCost;
        })
        .catch((e) => {
          console.warn(e);
          this.loadingShippingCostModel = false;
          this.data.cost_shipping = 0;
        });
    },
    formatItemText(item) {
      return `${item.type} - ${item.weight} kg`;
    },
    // checkBlackListName() {
    //   // if (this.data.name.length == 3)
    //   cl.checkBlackList({ full_name: this.data.dest_name }).then((res) => {
    //     this.nameStatus = res.data.data;
    //   });
    // },
    postpackage(print = false) {
      this.$refs.form.validate();
      if (this.valid == false) return;
      this.clicked = true;

      const payload = {
        cost_shipping: this.data.cost_shipping,
        // did: null,
        id_cost: this.typeOfchecked.id,
        // id_type: this.typeOfchecked.type,
        // type: this.typeOfchecked.type,
        note: this.data.note,

        dest_city: this.data.dest_city.id,
        dest_number: this.data.dest_number, //
        dest_name: this.data.dest_name, //
        dest_address: this.data.dest_address,
        dest_lat: this.data.dest_lat,
        dest_lng: this.data.dest_lng,
        dest_email: this.data.dest_email,

        sender_name: this.data.sender_name, //
        sender_address: this.data.sender_address, //
        sender_email: this.data.sender_email,

        price_package: this.data.price,
        cost_box: this.data.cost_box,
        verification: this.data.verification,
        future_options: {
          cid: this.future_dest.cid,
          src_id: this.future_dest.id,
          city: this.future_dest.city,
        },
        endpoint: this.data.endpoint,
        pickup: this.data.pickup,
      };
      if (payload.dest_lat == null) {
        window.alert(
          "We can't find GPS address ,The system will use only litter address!!"
        );
        // this.clicked = false;
        // return;
      }

      // payload.currency =
      //   this.$i18n.locale == "ar"
      //     ? this.src_place.costModel.ar_currency
      //     : this.src_place.costModel.en_currency;

      // payload.src_address = this.src_place.name + "-" + this.src_place.address;
      // payload.src_lat = this.src_place.lat;
      // payload.src_lng = this.src_place.lng;
      payload.src_id = this.src_place.id;

      // }

      if (payload.dest_lat != null) {
        const d = this.$distance(
          payload.src_lat,
          payload.src_lng,
          payload.dest_lat,
          payload.dest_lng
        );
        if (d > 10) {
          const result = confirm(
            `distance more than 10 KM !!! approximately ${d} KM`
          );
          if (result === true) {
          } else {
            this.clicked = false;
            return;
            // Your code for when the user cancels
          }
        }
      }

      // if (this.brodcast == true) delete payload.did;
      cl.add(payload)
        .then((res) => {
          const item = res.data.data;
          this.$store.dispatch(
            "api/handleServiceException",
            { e: res },
            { root: true }
          );

          if (print) new Print(item, this.printGeoPlace(item.access_group));

          this.handleReset(); //call reset from
          this.clicked = false;
        })
        .catch(() => {
          this.$store.dispatch(
            "api/handleServiceException",
            { e: e },
            { root: true }
          );

          this.clicked = false;
        });

      // this.$db.collection("autoComplateTable").add(response.data);
      // this.$db
      //   .collection("autoComplateTable")
      //   .get()
      //   .then((res) => {});
    },
    printGeoPlace(id) {
      try {
        return this.geoPlace.find((element) => element.id == id);
      } catch {
        return null;
      }
    },
    handleReset() {
      // this.$refs.form.reset();
      // this.$refs.form.resetValidation();
      this.data.cost_shipping = 0;
      this.data.note = null;
      this.loadingShippingCostModel = true;
      this.data.dest_number = null;
      this.data.dest_name = null;
      this.data.dest_address = null;
      this.data.dest_lat = null;
      this.data.dest_lng = null;
      this.data.dest_email = null;
      this.data.sender_name = null;
      this.data.sender_address = null;
      this.data.sender_email = null;
      this.data.cost_box = 0;
      this.data.verification = 0;
      this.data.future_dest = {};
    },
    closeInfoAiModel() {
      this.shippingCostModelDialog = false;
    },
    autoSaveLocal() {
      localStorage.setItem("lastpackage", JSON.stringify(this.SinglePatient));
    },
    viewAdress() {
      try {
        return this.src_place.name;
      } catch {
        return "";
      }
    },
  },
};
</script>
<style>
.custom-hint .v-icon {
  color: red !important;
}

.custom-hint .v-messages__message {
  color: red !important;
}
</style>
